import { prop } from 'ramda'

import type { VendingMachineExternalServiceSettings, PutServiceIdParams } from 'app/dataTypes/vending/machine/externalServices'

import type { Request } from '../../../../../index'

type UrlParams = {
  machineId: number,
  external_service_id: string
}

type ApiParams = {
  active: boolean
}

export const convertParams = (params: PutServiceIdParams): [ApiParams, UrlParams] => {
  const { machineId, serviceId, active } = params
  return [
    {
      active,
    },
    {
      machineId,
      external_service_id: serviceId,
    }]
}

type ExternalServiceApi = {
  id: number
  active: boolean
}

type ApiResult = {
  result: 'success'
  data: ExternalServiceApi
}



export const convertResult = (data: ApiResult): VendingMachineExternalServiceSettings => {
  const item = prop('data', data) || {}
  const { id, active } = item
  return {
    serviceId: id.toString(),
    active
  }
}

export const PUT_VENDING_MACHINES_EXTERNAL_SERVICES_SETTINGS: Request<PutServiceIdParams, VendingMachineExternalServiceSettings, UrlParams> = [
  'data/vending/machines/{machineId}/external_services_settings/{external_service_id}',
  'put',
  ['data'],
]
